'use client';

import QuarkLogo from '@/assets/logos/quark/dark-h.svg';
import { Close } from '@mui/icons-material';
import { AppBar, Box, Toolbar } from '@mui/material';
import { AppShellTriggerIcon } from '@prismo-io/design-system';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { SidebarAppetenceList } from './appetence-list';
import { SidebarExperienceList } from './experience-list';
import { SidebarFormationList } from './formation-list';
import { SidebarSkillList } from './skill-list';
type Props = {};
export const Sidebar = (props: Props) => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const pathname = usePathname();
  useEffect(() => {
    setActiveStep(STEPS.findIndex(({
      path
    }) => pathname.endsWith(path)));
  }, [pathname]);
  const STEPS = [{
    labelSidebar: 'Experiences',
    path: '/experiences'
  }, {
    labelSidebar: 'Formations',
    path: '/formations'
  }, {
    labelSidebar: 'Competences',
    path: '/competences'
  }, {
    labelSidebar: 'Appetences',
    path: '/appetences'
  }];
  return <>
      <AppBar position="static" color="transparent" variant="outlined" elevation={0} sx={{
      border: 'none'
    }} data-sentry-element="AppBar" data-sentry-source-file="index.tsx">
        <Toolbar variant="dense" data-sentry-element="Toolbar" data-sentry-source-file="index.tsx">
          <Image src={QuarkLogo} alt="Logo de Quark" height={32} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
          <Box component="div" flexGrow={1} data-sentry-element="Box" data-sentry-source-file="index.tsx" />
          {/* <ReadingKeyModal isDefaultOpen isQuestionBtn>
            <TipModalContent />
           </ReadingKeyModal> */}
          <AppShellTriggerIcon sx={{
          display: {
            node: 'block',
            md: 'none'
          }
        }} data-sentry-element="AppShellTriggerIcon" data-sentry-source-file="index.tsx">
            <Close data-sentry-element="Close" data-sentry-source-file="index.tsx" />
          </AppShellTriggerIcon>
        </Toolbar>
      </AppBar>
      <Box component="div" paddingY={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {pathname.endsWith('/experiences') && <SidebarExperienceList />}
        {pathname.endsWith('/formations') && <SidebarFormationList />}
        {pathname.endsWith('/competences') && <SidebarSkillList />}
        {pathname.endsWith('/appetences') && <SidebarAppetenceList />}
      </Box>
    </>;
};